<mat-dialog-content class="modal-content">
    <div class="relative flex flex-0 flex-col border-b py-4 sm:flex-row sm:items-center sm:justify-between">
        <div class="text-2xl font-extrabold tracking-tight">{{this.data?.code}} - {{this.data?.name}}</div>
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
            <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)"/>
            </mat-form-field>
            <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo registro">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
            </button>
        </div>
    </div>
    <div class="flex flex-auto overflow-hidden flex-col">
        <div class="container mt-0 flex-auto flex-col overflow-x-auto">
            <div class="sticky top-0 z-10 dark:bg-gray-900">
                <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSource"
                    matSort (matSortChange)="changeSort($event)">
                    <ng-container matColumnDef="field9">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Cantidad</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-left">
                            {{element?.field9 || "-"}} ({{element?.unitMeasure?.name}})
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="materialPromotion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Producto a Promocionar</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-left">
                            <b>{{element?.materialPromotion?.code}}</b><br>
                            {{element?.materialPromotion?.name}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="field12">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Cantidad a Promocionar</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-left">
                            {{element?.field12 || "-"}} ({{element?.unitMeasurePromotion?.name}})
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="dateEnd">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Vigencia</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-left">
                            {{element?.dateStart}} - {{element?.dateEnd}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                        <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                            <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionMenu="matMenu">
                                <button mat-menu-item (click)="openEditModal(element)">
                                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                    <span>Editar Registro</span>
                                </button>
                                <button mat-menu-item (click)="openDeleteDialog(element)">
                                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                    <span>Eliminar Registro</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr>                
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
                </table>
                <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl tracking-tight sm:p-10">Lo sentimos, no hay registros para mostrar.
                </div>
            </div>
        </div>
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
              [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>

<!-- Modales -->
<ng-template #addModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
    <mat-dialog-content class="modal-content">
        <form #createForm="ngForm">
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Organización Ventas</mat-label>
                    <mat-select [(ngModel)]="currentCreatePromotionList.distributionChainId" name="distributionChainId" required>
                        @for (item of salesOrganizationList; track item) {
                        <mat-option [value]="item._id">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Lista de Promociones</mat-label>
                    <mat-select [(ngModel)]="currentCreatePromotionList.promotionListId" name="promotionListId" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchPriceList" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsPriceList($event)" placeholderLabel="Buscar precio de lista..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (price of listFilterPriceList; track price) {
                        <mat-option [value]="price._id">
                            <b>{{price.code}}</b> - {{price.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="grid grid-cols-3 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material</mat-label>
                    <mat-select [(ngModel)]="currentCreatePromotionList.itemId" name="itemId" (selectionChange)="getUnitType('N')" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialList; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cantidad</mat-label>
                    <input matInput type="number" [(ngModel)]="currentCreatePromotionList.quantity" name="quantity" required>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida</mat-label>
                    <mat-select [(ngModel)]="currentCreatePromotionList.unitMeasureId" name="unitMeasureId" required>
                        @for (unit of unitMeasureList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material a Promocionar</mat-label>
                    <mat-select [(ngModel)]="currentCreatePromotionList.promotionItemId" name="promotionItemId" (selectionChange)="getUnitType()" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterialPromotional" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterialPromotional($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialListPromotional; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cantidad a Promocionar</mat-label>
                    <input matInput type="number" [(ngModel)]="currentCreatePromotionList.promotionQuantity" name="promotionQuantity" required>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida a Promocionar</mat-label>
                    <mat-select [(ngModel)]="currentCreatePromotionList.promotionUnitMeasureId" name="promotionUnitMeasureId" required>
                        @for (unit of unitMeasurePromotionList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>        
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field class="w-full">
                    <mat-label>Desde</mat-label>
                    <input matInput [matDatepicker]="dateStart" [(ngModel)]="currentCreatePromotionList.dateStart" name="dateStart">
                    <mat-datepicker-toggle matIconSuffix [for]="dateStart"></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                </mat-form-field>
    
                <mat-form-field class="w-full">
                    <mat-label>Hasta</mat-label>
                    <input matInput [matDatepicker]="dateEnd" [(ngModel)]="currentCreatePromotionList.dateEnd" name="dateEnd">
                    <mat-datepicker-toggle matIconSuffix [for]="dateEnd"></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createPromotionList()"
            [disabled]="!createForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #editModal>
    <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
    <mat-dialog-content class="modal-content">
        <form #editForm="ngForm">
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Organización Ventas</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePromotionList.field1" name="field1" required>
                        @for (item of salesOrganizationList; track item) {
                        <mat-option [value]="item._id">
                            {{ item.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Lista de Promociones</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePromotionList.field4" name="field4" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchPriceList" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsPriceList($event)" placeholderLabel="Buscar precio de lista..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (price of listFilterPriceList; track price) {
                        <mat-option [value]="price._id">
                            <b>{{price.code}}</b> - {{price.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="grid grid-cols-3 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePromotionList.field6" name="field6" (selectionChange)="getUnitEditType('N')" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialList; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cantidad</mat-label>
                    <input matInput type="number" [(ngModel)]="currentUpdatePromotionList.field9" name="field9" required [min]="0">
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePromotionList.field7" name="field7" required>
                        @for (unit of unitMeasureList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Material a Promocionar</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePromotionList.field10" name="field10" (selectionChange)="getUnitEditType()" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchMaterialPromotional" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="changueOptionsMaterialPromotional($event)" placeholderLabel="Buscar material..."
                                noEntriesFoundLabel="No se encontraron resultados">
                            </ngx-mat-select-search>
                        </mat-option>
                        @for (item of materialListPromotional; track item) {
                        <mat-option [value]="item._id">
                            <b>{{ item.code }}</b> - {{ item.name }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Cantidad a Promocionar</mat-label>
                    <input matInput type="number" [(ngModel)]="currentUpdatePromotionList.field12" name="field12" required [min]="0">
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-full">
                    <mat-label>Unidad Medida a Promocionar</mat-label>
                    <mat-select [(ngModel)]="currentUpdatePromotionList.field11" name="field11" required>
                        @for (unit of unitMeasurePromotionList; track unit) {
                        <mat-option [value]="unit.unitOfMeasure?._id">
                            <b>{{unit.unitOfMeasure?.code}}</b> - {{unit.unitOfMeasure?.name}}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>        
            <div class="grid grid-cols-2 gap-4">
                <mat-form-field class="w-full">
                    <mat-label>Desde</mat-label>
                    <input matInput [matDatepicker]="dateStart" [(ngModel)]="currentUpdatePromotionList.dateStart" name="dateStart">
                    <mat-datepicker-toggle matIconSuffix [for]="dateStart"></mat-datepicker-toggle>
                    <mat-datepicker #dateStart></mat-datepicker>
                </mat-form-field>
    
                <mat-form-field class="w-full">
                    <mat-label>Hasta</mat-label>
                    <input matInput [matDatepicker]="dateEnd" [(ngModel)]="currentUpdatePromotionList.dateEnd" name="dateEnd">
                    <mat-datepicker-toggle matIconSuffix [for]="dateEnd"></mat-datepicker-toggle>
                    <mat-datepicker #dateEnd></mat-datepicker>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateMaterialPriceList(currentUpdatePromotionList._id)"
            [disabled]="!editForm.valid">Guardar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #deleteDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>¿Está seguro que desea eliminar el registro?</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
    </mat-dialog-actions>
</ng-template>